/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithAccountItemRequestBuilder, WithAccountItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /scheduledtransactions/account
 */
export interface AccountRequestBuilder extends BaseRequestBuilder<AccountRequestBuilder> {
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.scheduledtransactions.account.item collection
     * @param accountId The Guid identifer of the account
     * @returns {WithAccountItemRequestBuilder}
     */
     byAccountId(accountId: Guid) : WithAccountItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const AccountRequestBuilderUriTemplate = "{+baseurl}/scheduledtransactions/account";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AccountRequestBuilderNavigationMetadata: Record<Exclude<keyof AccountRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byAccountId: {
        requestsMetadata: WithAccountItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["accountId"],
    },
};
/* tslint:enable */
/* eslint-enable */
